/**
 * Hide Okendo reviews below 4 stars on product pages.
 * Okendo injects reviews asynchronously, so we observe DOM changes.
 */
(function () {
  var MIN_STARS = 4;
  var REVIEW_ITEM_SELECTOR = '.oke-w-reviews-list-item';
  var HIDDEN_CLASS = 'oke-w-reviews-list-item--below-min-rating';

  function isProductPage() {
    return document.body && document.body.classList.contains('template-product');
  }

  function getRatingFromItem(item) {
    var a11y = item.querySelector('.oke-a11yText');
    if (a11y && a11y.textContent) {
      var match = a11y.textContent.match(/Rated\s+(\d+)\s+out\s+of\s+5\s+stars/i);
      if (match) return parseInt(match[1], 10);
    }

    var title = item.querySelector('.oke-reviewContent-title');
    if (title && title.textContent) {
      var titleMatch = title.textContent.match(/(\d+)\s+Star/i);
      if (titleMatch) return parseInt(titleMatch[1], 10);
    }

    var foreground = item.querySelector('.oke-stars-foreground');
    if (foreground && foreground.style.width) {
      var width = parseFloat(foreground.style.width);
      if (!isNaN(width)) return Math.round(width / 20);
    }

    return null;
  }

  function filterReviews(root) {
    var scope = root || document;
    var items = scope.querySelectorAll(REVIEW_ITEM_SELECTOR);

    items.forEach(function (item) {
      var stars = getRatingFromItem(item);
      if (stars === null) return;

      if (stars < MIN_STARS) {
        item.classList.add(HIDDEN_CLASS);
        item.setAttribute('hidden', '');
        item.setAttribute('aria-hidden', 'true');
      } else {
        item.classList.remove(HIDDEN_CLASS);
        item.removeAttribute('hidden');
        item.removeAttribute('aria-hidden');
      }
    });
  }

  function init() {
    if (!isProductPage()) return;

    filterReviews(document);

    var observer = new MutationObserver(function (mutations) {
      var shouldRun = mutations.some(function (mutation) {
        return mutation.addedNodes.length > 0;
      });
      if (shouldRun) filterReviews(document);
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
